import type { Report } from './presentationModel';
import { dimensionLabel, ratio, sum } from './presentationModel';

export function productMeasureRows(report: Report) {
  const groups = new Map<string, typeof report.productRows>();
  for (const row of report.productRows) {
    const name = dimensionLabel(row.product),
      group = groups.get(name) ?? [];
    group.push(row);
    groups.set(name, group);
  }
  return [...groups]
    .sort(([a], [b]) => a.localeCompare(b))
    .map(([name, source]) => {
      const clicks = sum(source, report.state.filters.mode === 'Unique' ? 'unique_clicks' : 'total_clicks'),
        items = sum(source, 'items'),
        gm = sum(source, 'gm'),
        ttv = sum(source, 'ttv');
      return { name, clicks, items, gm, ttv, cr: ratio(items, clicks), gmPerClick: ratio(gm, clicks) };
    });
}
